import React from "react";

import styles from "./RichTextComponent.css";

const RichTextComponent = () => {
	return (
		<div className={`ui form`} style={{ display: "flex" }}>
			<textarea
				className={styles.richtext}
				disabled={true}
				rows={3}
			/>
		</div>
	);
};

RichTextComponent.information = {
	type: "richText",
	name: "Rich Text"
};

export default RichTextComponent;
